module.exports = __webpack_public_path__ + "static/media/App_Download.fee44acb.svg";